<script setup lang="ts">
const props = defineProps<{
  url: string
  title?: string
  description?: string
}>()

const { copy, copied } = useClipboard()
const toast = useToast()

const shareData = computed(() => {
  const encodedUrl = encodeURIComponent(props.url)
  const encodedTitle = encodeURIComponent(props.title || '')
  const encodedDescription = encodeURIComponent(props.description || '')

  return {
    email: `mailto:?subject=${encodedTitle}&body=${encodedDescription}%20${encodedUrl}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
    twitter: `https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}`,
    pinterest: `https://pinterest.com/pin/create/button/?url=${encodedUrl}&description=${encodedDescription}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
    whatsapp: `https://api.whatsapp.com/send?text=${encodedTitle}%20${encodedUrl}`,
  }
})

const items = computed(() => [
  [
    {
      label: 'Email',
      icon: 'i-heroicons-envelope',
      to: shareData.value.email,
      target: '_blank'
    },
    {
      label: 'Facebook',
      icon: 'i-simple-icons-facebook',
      to: shareData.value.facebook,
      target: '_blank'
    },
    {
      label: 'X (Twitter)',
      icon: 'i-simple-icons-x',
      to: shareData.value.twitter,
      target: '_blank'
    },
    {
      label: 'Pinterest',
      icon: 'i-simple-icons-pinterest',
      to: shareData.value.pinterest,
      target: '_blank'
    },
    {
      label: 'LinkedIn',
      icon: 'i-simple-icons-linkedin',
      to: shareData.value.linkedin,
      target: '_blank'
    },
    {
      label: 'WhatsApp',
      icon: 'i-simple-icons-whatsapp',
      to: shareData.value.whatsapp,
      target: '_blank'
    }
  ],
  [
    {
      label: 'Copier le lien',
      icon: 'i-heroicons-link',
      onSelect: (event: Event) => {
        event.preventDefault()
        copy(props.url)
        toast.add({
          title: 'Lien copié !',
          description: 'Le lien a été copié dans votre presse-papier.',
          color: 'success'
        })
      }
    }
  ]
])
</script>

<template>
  <UDropdownMenu :items="items" :content="{ align: 'start' }">
    <slot>
      <UButton
        icon="i-heroicons-share"
        variant="ghost"
        color="neutral"
        size="md"
      />
    </slot>
  </UDropdownMenu>
</template>
